"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Loader, CircleCheck, Wrench, ShieldCheck, Clock, MapPin } from "lucide-react";
function MantenimientoForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center py-10 text-center space-y-4 animate-in fade-in zoom-in duration-500">
                <div className="size-16 bg-primary/20 rounded-lg flex items-center justify-center mb-4">
                    <CircleCheck className="size-8 text-primary" />
                </div>
                <h3 className="text-2xl font-default font-semibold text-foreground">Demande Envoyée !</h3>
                <p className="text-muted-foreground max-w-sm">
                    {successMessage}
                </p>
                <Button onClick={resetForm} variant="outline" className="mt-6 border-primary text-primary hover:bg-primary/10">
                    Nouvelle demande
                </Button>
            </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <FormField control={control} name="name" rules={{
        required: "Le nom est obligatoire",
        minLength: {
          value: 2,
          message: "Mínimo 2 caractères"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-foreground/80">Nom complet</FormLabel>
                            <FormControl>
                                <Input className="bg-background/50 border-border/50 focus:border-primary" placeholder="Votre nom" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />

                <FormField control={control} name="phone" rules={{
        required: "Le téléphone est obligatoire",
        pattern: {
          value: /^[0-9+\-\s]{9,15}$/,
          message: "Téléphone non valide"
        }
      }} render={({
        field
      }) => <FormItem>
                            <FormLabel className="text-foreground/80">Téléphone</FormLabel>
                            <FormControl>
                                <Input type="tel" className="bg-background/50 border-border/50 focus:border-primary" placeholder="Votre numéro" {...field} />
                            </FormControl>
                            <FormMessage />
                        </FormItem>} />
            </div>

            <FormField control={control} name="email" rules={{
      required: "L'email est obligatoire",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Email non valide"
      }
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="text-foreground/80">Courriel</FormLabel>
                        <FormControl>
                            <Input type="email" className="bg-background/50 border-border/50 focus:border-primary" placeholder="votre@email.com" {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>} />

            <FormField control={control} name="locality" rules={{
      required: "Le type de prêt est obligatoire"
    }} render={({
      field
    }) => <FormItem>
                        <FormLabel className="text-foreground/80">Type de prêt</FormLabel>
                        <Select onValueChange={field.onChange} defaultValue={field.value}>
                            <FormControl>
                                <SelectTrigger className="bg-background/50 border-border/50 focus:border-primary">
                                    <SelectValue placeholder="Sélectionnez une option" />
                                </SelectTrigger>
                            </FormControl>
                            <SelectContent>
                                <SelectItem value="Achat">Achat de propriété</SelectItem>
                                <SelectItem value="Refinancement">Refinancement</SelectItem>
                                <SelectItem value="Travailleur Autonome">Travailleur autonome</SelectItem>
                                <SelectItem value="Crédit Difficile">Crédit difficile</SelectItem>
                                <SelectItem value="Autre">Autre situation complexe</SelectItem>
                            </SelectContent>
                        </Select>
                        <FormMessage />
                    </FormItem>} />

            <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
                        <FormLabel className="text-foreground/80">Détails de votre situation (Optionnel)</FormLabel>
                        <FormControl>
                            <textarea className="flex min-h-[100px] w-full rounded-md border border-border/50 bg-background/50 px-3 py-2 text-sm shadow-xs placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/20 disabled:cursor-not-allowed disabled:opacity-50 resize-y" placeholder="Décrivez brièvement votre besoin..." {...field} />
                        </FormControl>
                        <FormMessage />
                    </FormItem>} />

            {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md text-sm text-destructive">
                    {submitError}
                </div>}

            <Button type="submit" disabled={isSubmitting} className="w-full h-11 text-base mt-2 bg-primary text-primary-foreground hover:bg-primary/90 font-default font-semibold tracking-wide">
                {isSubmitting ? <>
                        <Loader className="animate-spin mr-2 size-5" />
                        Traitement en cours...
                    </> : 'Obtenir une analyse gratuite'}
            </Button>
        </Form>;
}
export default function PrTTransformerVotreSituation() {
  return <section data-section-id="256420" id="prêt-à-transformer-votre-situation" className="dark py-16 md:py-24 bg-background text-foreground relative overflow-hidden">
            {}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none z-0">
                <div className="absolute -top-[10%] -right-[5%] w-[40%] h-[40%] rounded-lg bg-primary/10 blur-3xl" />
                <div className="absolute -bottom-[10%] -left-[5%] w-[40%] h-[40%] rounded-lg bg-secondary/5 blur-3xl" />
            </div>

            <div className="container mx-auto px-4 md:px-6 relative z-10">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
                    
                    {}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 text-primary text-sm font-default font-medium tracking-wider uppercase">
                                <ShieldCheck className="size-4" />
                                <span>Expertise Hypothécaire Québec</span>
                            </div>
                            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-foreground leading-tight">Réponse rapide</h2>
                            <p className="text-lg text-muted-foreground max-w-lg font-default">
                                Ne laissez pas un refus freiner vos projets. Nous trouvons des solutions là où les institutions traditionnelles s'arrêtent.
                            </p>
                        </div>

                        <div className="space-y-6">
                            {[{
              icon: <Clock className="size-6 text-primary" />,
              title: "Rapidité d'exécution",
              description: "Une analyse complète de votre dossier effectuée en un temps record."
            }, {
              icon: <Wrench className="size-6 text-primary" />,
              title: "Solutions sur mesure",
              description: "Spécialiste des dossiers complexes : travailleurs autonomes et crédit difficile."
            }, {
              icon: <MapPin className="size-6 text-primary" />,
              title: "Partout au Québec",
              description: "Un accompagnement personnalisé, peu importe votre localisation."
            }].map((feature, i) => <div key={i} data-index={i} className="flex gap-4">
                                    <div className="shrink-0 mt-1 bg-secondary/20 p-2 rounded-md h-fit">
                                        {feature.icon}
                                    </div>
                                    <div>
                                        <h4 className="text-base font-default font-semibold text-foreground">{feature.title}</h4>
                                        <p className="text-sm text-muted-foreground mt-1 font-default">{feature.description}</p>
                                    </div>
                                </div>)}
                        </div>
                    </div>

                    {}
                    <div className="lg:pl-8">
                        <Card className="border-border/30 bg-card/40 backdrop-blur-md shadow-2xl shadow-black/20 rounded-md">
                            <CardHeader className="pb-4">
                                <CardTitle className="text-2xl font-serif">Demande de consultation</CardTitle>
                                <CardDescription className="font-default">
                                    Confidentialité assurée. Remplissez ce formulaire pour une évaluation sans engagement.
                                </CardDescription>
                            </CardHeader>
                            <CardContent>
                                <FormProvider formKey="mortgage_lead_form_home" formId="mortgage_lead_form_home" sectionName="prêt-à-transformer-votre-situation" defaultValues={{
                name: "",
                phone: "",
                email: "",
                locality: "Achat",
                message: ""
              }} submitText="Obtenir une analyse gratuite" successMessage="Merci ! Votre demande a été transmise avec succès. Jenny Martel ou un membre de l'équipe vous contactera d'ici 24 heures.">
                                    <MantenimientoForm />
                                </FormProvider>
                            </CardContent>
                        </Card>
                    </div>

                </div>
            </div>
        </section>;
}